import React from "react";
import { Button, Col, Row, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useScheduleActionsContext } from "../contexts/ScheduleActions";

import { selectSelectedTournament } from "../../../../../features/tourneymgmt/tournamentManagementSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";
import { IMasterTournament } from "../../../../../types/api";

const PageHeader = (): React.JSX.Element => {
    const { showComponent, setShowComponent } = useScheduleActionsContext();
    const tournament = useAppSelector(
        selectSelectedTournament,
    ) as IMasterTournament;

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <p>
                        This page will allow you to make <b>bulk</b> actions to
                        the tournament schedule, such as moving all games from
                        one field to another or adjusting multiple game times or
                        lengths. To move/update individual games, please use the{" "}
                        <Link
                            to={`/tournament-management/tournament/${tournament.id}/calendar`}
                        >
                            Calendar Page
                        </Link>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Stack direction="horizontal" gap={2}>
                        <Button
                            onClick={() =>
                                setShowComponent({
                                    ...showComponent,
                                    moveGames: !showComponent["moveGames"],
                                })
                            }
                        >
                            Move Games
                        </Button>
                        <Button
                            onClick={() =>
                                setShowComponent({
                                    ...showComponent,
                                    adjustStarts:
                                        !showComponent["adjustStarts"],
                                })
                            }
                        >
                            Adjust Start Times
                        </Button>
                        <Button
                            onClick={() =>
                                setShowComponent({
                                    ...showComponent,
                                    adjustLengths:
                                        !showComponent["adjustLengths"],
                                })
                            }
                        >
                            Adjust Game Lengths
                        </Button>
                    </Stack>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default PageHeader;
